<!-- 开通线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo": "粤A12345",
                "billCode": "wdl201904250001",
                "parkCodes": "PR2WCYG4,2KKN6112",
                "originPrice": 10,
                "favorPrice": 5,
                "payMode": 4,
                "payModeRemark": "微信支付",
                "payOrigin": 7,
                "payOriginRemark": "智慧停车",
                "userName": "王五11",
                "userPhone": "18000000000",
                "monthTicketConfigId": 537,
                "timePeriodList": [
                    {
                        "startTime": "2019-04-25 01:11:25",
                        "endTime": "2019-04-27 00:11:25"
                    }
                ]
            },
            responseCode: {
                "data": {
                    "monthTicketId": 11
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台开通线上月票",
                t_url: this.commonUrls.test + "addOnlineMonthTicket",
                p_url: this.commonUrls.prod + "addOnlineMonthTicket",
                precondition: "无",
                fitSystem: "云停车场,VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'parkCodes', info2: '是', info3: 'String', info4: '停车场编号列表，需与线上月票类型权限的parkCodes完全一致方可创建' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码,多个车牌号码时规则(测X123456,测X234567)' },
                        { info1: 'carNoColor', info2: '是', info3: 'String', info4: '车牌颜色，当车牌号码存在预约车牌时生效<url>参考附录:/Api/appendixData#appendixData_7</url>' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统订单号（不超过32位）' },
                        { info1: 'userName', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'userPhone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'originPrice', info2: '是', info3: 'Decimal', info4: '票原价，单位元' },
                        { info1: 'favorPrice', info2: '是', info3: 'Decimal', info4: '票折后价，单位元' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData#appendixData_1</url>' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData#appendixData_0</url>' },
                        { info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'timePeriodList', info2: '是', info3: 'JSONArray', info4: '有效时间段列表' },
                        { info1: 'thirdpartyIdentify', info2: '否', info3: 'String', info4: '授权商标识key(预约月票开通必填)，需先调用接口deductMonthTicketConfig' },
                        { info1: 'thirdPartyBillCode', info2: '否', info3: 'String', info4: '授权商标识账单号，当thirdpartyIdentify不为空时生效，需先调用接口deductMonthTicketConfig' },
                        { info1: 'dynamicCarportNumber', info2: '否', info3: 'Integer', info4: '可用车位，默认为1，默认根据carNo而改变，当月票类型支持时多位多车时可允许设置，否则不可以设置' },
                        { info1: 'receiveAccount', info2: '否', info3: 'String', info4: '到账商户号，建议32位以内' },
                        { info1: 'payTime', info2: '否', info3: 'String', info4: '支付时间，格式：yyyyMMddHHmmss' },
                        { info1: 'userUniqueCode', info2: '否', info3: 'String', info4: '用户唯一编码' },
                        { info1: 'buyMethod', info2: '否', info3: 'Integer', info4: '购买方式：0后台添加，1 自助购买，2 第三方添加' },
                        
                    ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketId', info2: '是', info3: 'Long', info4: '月票id' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/addOnlineMonthTicket.vue